/**
 * Strings de permissão do sistema centralizadas.
 * Sincronizado com as migrações do backend (V2 até V34).
 */

export const PERMISSIONS = {
  // ─── Wallet (Own) ──────────────────────────────────────────────
  CAN_ADD_CREDENTIALS_TO_OWN_WALLET: "CAN_ADD_CREDENTIALS_TO_OWN_WALLET",
  CAN_ADD_FILES_TO_OWN_WALLET: "CAN_ADD_FILES_TO_OWN_WALLET",
  CAN_CREATE_OWN_WALLET: "CAN_CREATE_OWN_WALLET",
  CAN_DELETE_OWN_WALLET: "CAN_DELETE_OWN_WALLET",
  CAN_DELETE_OWN_WALLET_CREDENTIAL: "CAN_DELETE_OWN_WALLET_CREDENTIAL",
  CAN_DELETE_OWN_WALLET_FILE: "CAN_DELETE_OWN_WALLET_FILE",
  CAN_GENERATE_PDF_TO_OWN_WALLET: "CAN_GENERATE_PDF_TO_OWN_WALLET",
  CAN_GENERATE_SPREADSHEET_TO_OWN_WALLET: "CAN_GENERATE_SPREADSHEET_TO_OWN_WALLET",
  CAN_GET_OWN_WALLET: "CAN_GET_OWN_WALLET",
  CAN_UPLOAD_OWN_WALLET_FILE: "CAN_UPLOAD_OWN_WALLET_FILE",
  // ─── Wallet (Project) ─────────────────────────────────────────
  CAN_ADD_CREDENTIALS_TO_PROJECT_WALLET: "CAN_ADD_CREDENTIALS_TO_PROJECT_WALLET",
  CAN_ADD_FILES_TO_PROJECT_WALLET: "CAN_ADD_FILES_TO_PROJECT_WALLET",
  CAN_CREATE_PROJECT_WALLET: "CAN_CREATE_PROJECT_WALLET",
  CAN_DELETE_PROJECT_WALLET: "CAN_DELETE_PROJECT_WALLET",
  CAN_DELETE_PROJECT_WALLET_CREDENTIAL: "CAN_DELETE_PROJECT_WALLET_CREDENTIAL",
  CAN_DELETE_PROJECT_WALLET_FILE: "CAN_DELETE_PROJECT_WALLET_FILE",
  CAN_GENERATE_PDF_TO_PROJECT_WALLET: "CAN_GENERATE_PDF_TO_PROJECT_WALLET",
  CAN_GENERATE_SPREADSHEET_TO_PROJECT_WALLET: "CAN_GENERATE_SPREADSHEET_TO_PROJECT_WALLET",
  CAN_GET_PROJECT_WALLET_FILE: "CAN_GET_PROJECT_WALLET_FILE",
  CAN_UPLOAD_PROJECT_WALLET_FILE: "CAN_UPLOAD_PROJECT_WALLET_FILE",
  // ─── Wallet (Step) ────────────────────────────────────────────
  CAN_ADD_CREDENTIALS_TO_STEP_WALLET: "CAN_ADD_CREDENTIALS_TO_STEP_WALLET",
  CAN_ADD_FILES_TO_STEP_WALLET: "CAN_ADD_FILES_TO_STEP_WALLET",
  CAN_CREATE_STEP_WALLET: "CAN_CREATE_STEP_WALLET",
  CAN_DELETE_STEP_WALLET: "CAN_DELETE_STEP_WALLET",
  CAN_DELETE_STEP_WALLET_CREDENTIAL: "CAN_DELETE_STEP_WALLET_CREDENTIAL",
  CAN_DELETE_STEP_WALLET_FILE: "CAN_DELETE_STEP_WALLET_FILE",
  CAN_GENERATE_PDF_TO_STEP_WALLET: "CAN_GENERATE_PDF_TO_STEP_WALLET",
  CAN_GENERATE_SPREADSHEET_TO_STEP_WALLET: "CAN_GENERATE_SPREADSHEET_TO_STEP_WALLET",
  CAN_GET_STEP_WALLET_FILE: "CAN_GET_STEP_WALLET_FILE",
  CAN_UPLOAD_STEP_WALLET_FILE: "CAN_UPLOAD_STEP_WALLET_FILE",
  // ─── Wallet (User) ────────────────────────────────────────────
  CAN_ADD_CREDENTIALS_TO_USER_WALLET: "CAN_ADD_CREDENTIALS_TO_USER_WALLET",
  CAN_ADD_FILES_TO_USER_WALLET: "CAN_ADD_FILES_TO_USER_WALLET",
  CAN_CREATE_USER_WALLET: "CAN_CREATE_USER_WALLET",
  CAN_DELETE_USER_WALLET: "CAN_DELETE_USER_WALLET",
  CAN_DELETE_USER_WALLET_CREDENTIAL: "CAN_DELETE_USER_WALLET_CREDENTIAL",
  CAN_DELETE_USER_WALLET_FILE: "CAN_DELETE_USER_WALLET_FILE",
  CAN_GENERATE_PDF_TO_USER_WALLET: "CAN_GENERATE_PDF_TO_USER_WALLET",
  CAN_GENERATE_SPREADSHEET_TO_USER_WALLET: "CAN_GENERATE_SPREADSHEET_TO_USER_WALLET",
  CAN_GET_USER_WALLET_FILE: "CAN_GET_USER_WALLET_FILE",
  CAN_UPLOAD_USER_WALLET_FILE: "CAN_UPLOAD_USER_WALLET_FILE",
  // ─── Wallet (System Profile) ──────────────────────────────────
  CAN_ADD_CREDENTIALS_TO_SYSTEM_PROFILE_WALLET: "CAN_ADD_CREDENTIALS_TO_SYSTEM_PROFILE_WALLET",
  CAN_ADD_FILES_TO_SYSTEM_PROFILE_WALLET: "CAN_ADD_FILES_TO_SYSTEM_PROFILE_WALLET",
  CAN_CREATE_SYSTEM_PROFILE_WALLET: "CAN_CREATE_SYSTEM_PROFILE_WALLET",
  CAN_DELETE_SYSTEM_PROFILE_WALLET: "CAN_DELETE_SYSTEM_PROFILE_WALLET",
  CAN_DELETE_SYSTEM_PROFILE_WALLET_CREDENTIAL: "CAN_DELETE_SYSTEM_PROFILE_WALLET_CREDENTIAL",
  CAN_DELETE_SYSTEM_PROFILE_WALLET_FILE: "CAN_DELETE_SYSTEM_PROFILE_WALLET_FILE",
  CAN_GET_SYSTEM_PROFILE_WALLET_FILE: "CAN_GET_SYSTEM_PROFILE_WALLET_FILE",
  CAN_UPLOAD_SYSTEM_PROFILE_WALLET_FILE: "CAN_UPLOAD_SYSTEM_PROFILE_WALLET_FILE",
  CAN_EXTRACT_DOCUMENTS: "CAN_EXTRACT_DOCUMENTS",
  // ─── Users ─────────────────────────────────────────────────────
  CAN_CREATE_USER: "CAN_CREATE_USER",
  CAN_DISABLE_USER: "CAN_DISABLE_USER",
  CAN_EDIT_USER: "CAN_EDIT_USER",
  CAN_ENABLE_USER: "CAN_ENABLE_USER",
  CAN_GET_OWN_USER: "CAN_GET_OWN_USER",
  CAN_GET_USER: "CAN_GET_USER",
  CAN_LIST_USERS: "CAN_LIST_USERS",
  CAN_LOGOUT_USER: "CAN_LOGOUT_USER",
  CAN_UPDATE_OWN_USER: "CAN_UPDATE_OWN_USER",
  CAN_SET_PROFILE_IMAGE: "CAN_SET_PROFILE_IMAGE",
  CAN_GET_PROFILE_IMAGE: "CAN_GET_PROFILE_IMAGE",

  // ─── Roles ─────────────────────────────────────────────────────
  CAN_CREATE_ROLE: "CAN_CREATE_ROLE",
  CAN_GET_ROLE: "CAN_GET_ROLE",
  CAN_GET_ROLES: "CAN_GET_ROLES",
  CAN_LIST_ROLES: "CAN_LIST_ROLES",
  CAN_LIST_ROLE_PERMISSIONS: "CAN_LIST_ROLE_PERMISSIONS",
  CAN_UPDATE_ROLE: "CAN_UPDATE_ROLE",

  // ─── Profiles ──────────────────────────────────────────────────
  CAN_CREATE_PROFILE: "CAN_CREATE_PROFILE",
  CAN_DISABLE_PROFILE: "CAN_DISABLE_PROFILE",
  CAN_GET_PROFILE: "CAN_GET_PROFILE",
  CAN_LIST_PROFILES: "CAN_LIST_PROFILES",

  // ─── System Profiles ──────────────────────────────────────────
  CAN_CREATE_SYSTEM_PROFILE: "CAN_CREATE_SYSTEM_PROFILE",
  CAN_DISABLE_SYSTEM_PROFILE: "CAN_DISABLE_SYSTEM_PROFILE",
  CAN_GET_SYSTEM_PROFILE: "CAN_GET_SYSTEM_PROFILE",
  CAN_LIST_SYSTEM_PROFILES: "CAN_LIST_SYSTEM_PROFILES",
  CAN_UPDATE_SYSTEM_PROFILE: "CAN_UPDATE_SYSTEM_PROFILE",

  // ─── Suppliers ─────────────────────────────────────────────────
  CAN_CREATE_SUPPLIER: "CAN_CREATE_SUPPLIER",
  CAN_DISABLE_SUPPLIER: "CAN_DISABLE_SUPPLIER",
  CAN_GET_SUPPLIER: "CAN_GET_SUPPLIER",
  CAN_LIST_SUPPLIERS: "CAN_LIST_SUPPLIERS",
  CAN_UPDATE_SUPPLIER: "CAN_UPDATE_SUPPLIER",

  // ─── Employees ─────────────────────────────────────────────────
  CAN_CREATE_EMPLOYEE: "CAN_CREATE_EMPLOYEE",
  CAN_DISABLE_EMPLOYEE: "CAN_DISABLE_EMPLOYEE",
  CAN_GET_EMPLOYEE: "CAN_GET_EMPLOYEE",
  CAN_LIST_EMPLOYEES: "CAN_LIST_EMPLOYEES",
  CAN_UPDATE_EMPLOYEE: "CAN_UPDATE_EMPLOYEE",

  // ─── Independent Workers ───────────────────────────────────────
  CAN_CREATE_INDEPENDENT_WORKER: "CAN_CREATE_INDEPENDENT_WORKER",
  CAN_DISABLE_INDEPENDENT_WORKER: "CAN_DISABLE_INDEPENDENT_WORKER",
  CAN_GET_INDEPENDENT_WORKER: "CAN_GET_INDEPENDENT_WORKER",
  CAN_LIST_INDEPENDENT_WORKERS: "CAN_LIST_INDEPENDENT_WORKERS",
  CAN_UPDATE_INDEPENDENT_WORKER: "CAN_UPDATE_INDEPENDENT_WORKER",

  // ─── Collaborators ─────────────────────────────────────────────
  CAN_CREATE_COLLABORATOR: "CAN_CREATE_COLLABORATOR",
  CAN_DISABLE_COLLABORATOR: "CAN_DISABLE_COLLABORATOR",
  CAN_GET_COLLABORATOR: "CAN_GET_COLLABORATOR",
  CAN_LIST_COLLABORATORS: "CAN_LIST_COLLABORATORS",
  CAN_UPDATE_COLLABORATOR: "CAN_UPDATE_COLLABORATOR",

  // ─── Projects ──────────────────────────────────────────────────
  CAN_CREATE_PROJECT: "CAN_CREATE_PROJECT",
  CAN_DISABLE_PROJECT: "CAN_DISABLE_PROJECT",
  CAN_GET_PROJECT: "CAN_GET_PROJECT",
  CAN_LIST_PROJECTS: "CAN_LIST_PROJECTS",
  CAN_LIST_PARTICIPATING_PROJECTS: "CAN_LIST_PARTICIPATING_PROJECTS",
  CAN_UPDATE_PROJECT: "CAN_UPDATE_PROJECT",
  CAN_GET_BALANCE: "CAN_GET_BALANCE",
  CAN_GET_PROJECT_IMAGE: "CAN_GET_PROJECT_IMAGE",
  CAN_LIST_PROJECT_IMAGE: "CAN_LIST_PROJECT_IMAGE",
  CAN_UPLOAD_PROJECT_IMAGE: "CAN_UPLOAD_PROJECT_IMAGE",
  CAN_DELETE_PROJECT_IMAGE: "CAN_DELETE_PROJECT_IMAGE",

  // ─── Project Roles / Permissions ───────────────────────────────
  CAN_CREATE_PROJECT_ROLE: "CAN_CREATE_PROJECT_ROLE",
  CAN_DELETE_PROJECT_ROLE: "CAN_DELETE_PROJECT_ROLE",
  CAN_GET_PROJECT_ROLE: "CAN_GET_PROJECT_ROLE",
  CAN_LIST_PROJECT_ROLE: "CAN_LIST_PROJECT_ROLE",
  CAN_UPDATE_PROJECT_ROLE: "CAN_UPDATE_PROJECT_ROLE",
  CAN_GET_PROJECT_PERMISSION: "CAN_GET_PROJECT_PERMISSION",
  CAN_LIST_PROJECT_PERMISSION: "CAN_LIST_PROJECT_PERMISSION",
  CAN_UPDATE_PROJECT_PERMISSION: "CAN_UPDATE_PROJECT_PERMISSION",
  CAN_DELETE_PROJECT_PERMISSION: "CAN_DELETE_PROJECT_PERMISSION",
  CAN_LIST_PERMISSION: "CAN_LIST_PERMISSION",
  CAN_UPDATE_PERMISSION: "CAN_UPDATE_PERMISSION",

  // ─── Project Workers ──────────────────────────────────────────
  CAN_CREATE_PROJECT_WORKER: "CAN_CREATE_PROJECT_WORKER",
  CAN_DELETE_PROJECT_WORKER: "CAN_DELETE_PROJECT_WORKER",
  CAN_GET_PROJECT_WORKER: "CAN_GET_PROJECT_WORKER",
  CAN_LIST_PROJECT_WORKERS: "CAN_LIST_PROJECT_WORKERS",

  // ─── Steps ─────────────────────────────────────────────────────
  CAN_CREATE_STEP: "CAN_CREATE_STEP",
  CAN_DELETE_STEP: "CAN_DELETE_STEP",
  CAN_DISABLE_STEP: "CAN_DISABLE_STEP",
  CAN_GET_STEP: "CAN_GET_STEP",
  CAN_LIST_STEPS: "CAN_LIST_STEPS",
  CAN_UPDATE_STEP: "CAN_UPDATE_STEP",

  // ─── Tasks ─────────────────────────────────────────────────────
  CAN_CREATE_TASK: "CAN_CREATE_TASK",
  CAN_DELETE_TASK: "CAN_DELETE_TASK",
  CAN_FINISH_TASK: "CAN_FINISH_TASK",
  CAN_GET_TASK: "CAN_GET_TASK",
  CAN_LIST_TASKS: "CAN_LIST_TASKS",

  // ─── Step & Task Names (Generics) ─────────────────────────────
  CAN_CREATE_STEP_NAME: "CAN_CREATE_STEP_NAME",
  CAN_DELETE_STEP_NAME: "CAN_DELETE_STEP_NAME",
  CAN_GET_STEP_NAME: "CAN_GET_STEP_NAME",
  CAN_LIST_STEP_NAMES: "CAN_LIST_STEP_NAMES",
  CAN_UPDATE_STEP_NAME: "CAN_UPDATE_STEP_NAME",
  CAN_CREATE_TASK_NAME: "CAN_CREATE_TASK_NAME",
  CAN_DELETE_TASK_NAME: "CAN_DELETE_TASK_NAME",
  CAN_GET_TASK_NAME: "CAN_GET_TASK_NAME",
  CAN_LIST_TASK_NAMES: "CAN_LIST_TASK_NAMES",
  CAN_UPDATE_TASK_NAME: "CAN_UPDATE_TASK_NAME",

  // ─── Diaries ───────────────────────────────────────────────────
  CAN_CREATE_DIARY: "CAN_CREATE_DIARY",
  CAN_GET_DIARY: "CAN_GET_DIARY",
  CAN_LIST_DIARIES: "CAN_LIST_DIARIES",
  CAN_UPDATE_DIARY: "CAN_UPDATE_DIARY",
  CAN_CREATE_WORKER_DIARY: "CAN_CREATE_WORKER_DIARY",
  CAN_UPDATE_WORKER_DIARY: "CAN_UPDATE_WORKER_DIARY",
  CAN_GET_PROJECT_DIARY_IMAGE: "CAN_GET_PROJECT_DIARY_IMAGE",
  CAN_LIST_PROJECT_DIARY_IMAGE: "CAN_LIST_PROJECT_DIARY_IMAGE",
  CAN_UPLOAD_PROJECT_DIARY_IMAGE: "CAN_UPLOAD_PROJECT_DIARY_IMAGE",
  CAN_DELETE_PROJECT_DIARY_IMAGE: "CAN_DELETE_PROJECT_DIARY_IMAGE",

  // ─── Financial (Costs / Offer Costs) ──────────────────────────
  CAN_GET_COST: "CAN_GET_COST",
  CAN_LIST_COSTS: "CAN_LIST_COSTS",
  CAN_CREATE_OFFER_COST: "CAN_CREATE_OFFER_COST",
  CAN_DELETE_OFFER_COST: "CAN_DELETE_OFFER_COST",
  CAN_GET_OFFER_COST: "CAN_GET_OFFER_COST",
  CAN_LIST_OFFER_COSTS: "CAN_LIST_OFFER_COSTS",
  CAN_UPDATE_OFFER_COST: "CAN_UPDATE_OFFER_COST",
  CAN_CREATE_STEP_COSTS_OFFER_COST: "CAN_CREATE_STEP_COSTS_OFFER_COST",
  CAN_DELETE_STEP_COSTS_OFFER_COST: "CAN_DELETE_STEP_COSTS_OFFER_COST",
  CAN_GET_STEP_COSTS_OFFER_COST: "CAN_GET_STEP_COSTS_OFFER_COST",
  CAN_GET_STEP_COST: "CAN_GET_STEP_COST",
  CAN_GET_STEP_COST_COST: "CAN_GET_STEP_COST_COST",
  CAN_LIST_PROJECT_COSTS_STEP_COSTS: "CAN_LIST_PROJECT_COSTS_STEP_COSTS",
  CAN_LIST_PROJECTS_COSTS: "CAN_LIST_PROJECTS_COSTS",
  CAN_LIST_FINANCY: "CAN_LIST_FINANCY",
  CAN_LIST_PROFIT: "CAN_LIST_PROFIT",

  // ─── Receivements ─────────────────────────────────────────────
  CAN_CREATE_RECEIVEMENT: "CAN_CREATE_RECEIVEMENT",
  CAN_DELETE_RECEIVEMENT: "CAN_DELETE_RECEIVEMENT",
  CAN_GET_RECEIVEMENT: "CAN_GET_RECEIVEMENT",
  CAN_LIST_RECEIVEMENTS: "CAN_LIST_RECEIVEMENTS",
  CAN_LIST_RECEIVEMENTS_GLOBAL: "CAN_LIST_RECEIVEMENTS_GLOBAL",
  CAN_UPDATE_RECEIVEMENT: "CAN_UPDATE_RECEIVEMENT",
  CAN_GET_PROJECT_RECEIVEMENT: "CAN_GET_PROJECT_RECEIVEMENT",
  CAN_GET_STEP_RECEIVEMENT: "CAN_GET_STEP_RECEIVEMENT",
  CAN_GET_STEP_RECEIVEMENT_RECEIVEMENT: "CAN_GET_STEP_RECEIVEMENT_RECEIVEMENT",
  CAN_LIST_PROJECT_RECEIVEMENT_STEP_RECEIVEMENTS: "CAN_LIST_PROJECT_RECEIVEMENT_STEP_RECEIVEMENTS",

  // ─── Offers ────────────────────────────────────────────────────
  CAN_CREATE_OFFER: "CAN_CREATE_OFFER",
  CAN_DELETE_OFFER: "CAN_DELETE_OFFER",
  CAN_GET_OFFER: "CAN_GET_OFFER",
  CAN_LIST_OFFERS: "CAN_LIST_OFFERS",
  CAN_UPDATE_OFFER: "CAN_UPDATE_OFFER",

  // ─── Categories ────────────────────────────────────────────────
  CAN_CREATE_CATEGORY: "CAN_CREATE_CATEGORY",
  CAN_DELETE_CATEGORY: "CAN_DELETE_CATEGORY",
  CAN_GET_CATEGORY: "CAN_GET_CATEGORY",
  CAN_LIST_CATEGORIES: "CAN_LIST_CATEGORIES",
  CAN_UPDATE_CATEGORY: "CAN_UPDATE_CATEGORY",

  // ─── Country ───────────────────────────────────────────────────
  CAN_GET_COUNTRY: "CAN_GET_COUNTRY",

  // ─── Tools ─────────────────────────────────────────────────────
  CAN_CREATE_TOOL: "CAN_CREATE_TOOL",
  CAN_DELETE_TOOL: "CAN_DELETE_TOOL",
  CAN_GET_TOOL: "CAN_GET_TOOL",
  CAN_LIST_TOOLS: "CAN_LIST_TOOLS",
  CAN_UPDATE_TOOL: "CAN_UPDATE_TOOL",

  // ─── Storage ───────────────────────────────────────────────────
  CAN_CREATE_STORAGE: "CAN_CREATE_STORAGE",
  CAN_DELETE_STORAGE: "CAN_DELETE_STORAGE",
  CAN_GET_STORAGE: "CAN_GET_STORAGE",
  CAN_LIST_STORAGES: "CAN_LIST_STORAGES",
  CAN_UPDATE_STORAGE: "CAN_UPDATE_STORAGE",

  // ─── Stock ─────────────────────────────────────────────────────
  CAN_CREATE_STOCK: "CAN_CREATE_STOCK",
  CAN_DELETE_STOCK: "CAN_DELETE_STOCK",
  CAN_GET_STOCK: "CAN_GET_STOCK",
  CAN_LIST_STOCKS: "CAN_LIST_STOCKS",

  // ─── Stock Balances ────────────────────────────────────────────
  CAN_CREATE_PROJECT_STOCK_BALANCE: "CAN_CREATE_PROJECT_STOCK_BALANCE",
  CAN_CREATE_STORAGE_STOCK_BALANCE: "CAN_CREATE_STORAGE_STOCK_BALANCE",
  CAN_DELETE_STORAGE_STOCK_BALANCE: "CAN_DELETE_STORAGE_STOCK_BALANCE",
  CAN_GET_PROJECT_STOCK_BALANCE: "CAN_GET_PROJECT_STOCK_BALANCE",
  CAN_GET_STOCK_BALANCE: "CAN_GET_STOCK_BALANCE",
  CAN_LIST_STOCK_BALANCES: "CAN_LIST_STOCK_BALANCES",
  CAN_UPDATE_STORAGE_STOCK_BALANCE: "CAN_UPDATE_STORAGE_STOCK_BALANCE",

  // ─── Stock Tools ───────────────────────────────────────────────
  CAN_CREATE_PROJECT_STOCK_TOOL: "CAN_CREATE_PROJECT_STOCK_TOOL",
  CAN_CREATE_STORAGE_STOCK_TOOL: "CAN_CREATE_STORAGE_STOCK_TOOL",
  CAN_DELETE_PROJECT_STOCK_TOOL: "CAN_DELETE_PROJECT_STOCK_TOOL",
  CAN_DELETE_STORAGE_STOCK_TOOL: "CAN_DELETE_STORAGE_STOCK_TOOL",
  CAN_GET_PROJECT_STOCK_TOOL: "CAN_GET_PROJECT_STOCK_TOOL",
  CAN_GET_STOCK_TOOL: "CAN_GET_STOCK_TOOL",
  CAN_LIST_STOCK_TOOLS: "CAN_LIST_STOCK_TOOLS",
  CAN_UPDATE_PROJECT_STOCK_TOOL: "CAN_UPDATE_PROJECT_STOCK_TOOL",
  CAN_UPDATE_STORAGE_STOCK_TOOL: "CAN_UPDATE_STORAGE_STOCK_TOOL",

  // ─── Purchase Order Lists ─────────────────────────────────────
  CAN_CREATE_PURCHASE_ORDER_LIST: "CAN_CREATE_PURCHASE_ORDER_LIST",
  CAN_DISABLE_PURCHASE_ORDER_LIST: "CAN_DISABLE_PURCHASE_ORDER_LIST",
  CAN_DISPATCH_PURCHASE_ORDER_LIST: "CAN_DISPATCH_PURCHASE_ORDER_LIST",
  CAN_GET_PURCHASE_ORDER_LIST: "CAN_GET_PURCHASE_ORDER_LIST",
  CAN_LIST_PURCHASE_ORDER_LISTS: "CAN_LIST_PURCHASE_ORDER_LISTS",
  CAN_UPDATE_PURCHASE_ORDER_LIST: "CAN_UPDATE_PURCHASE_ORDER_LIST",

  // ─── Purchase Orders (Standalone) ─────────────────────────────
  CAN_CREATE_PURCHASE_ORDER: "CAN_CREATE_PURCHASE_ORDER",
  CAN_DISABLE_PURCHASE_ORDER: "CAN_DISABLE_PURCHASE_ORDER",
  CAN_DISPATCH_PURCHASE_ORDER: "CAN_DISPATCH_PURCHASE_ORDER",
  CAN_GET_PURCHASE_ORDER: "CAN_GET_PURCHASE_ORDER",
  CAN_LIST_PURCHASE_ORDERS: "CAN_LIST_PURCHASE_ORDERS",
  CAN_UPDATE_PURCHASE_ORDER: "CAN_UPDATE_PURCHASE_ORDER",

  // ─── Stock Purchase Orders ────────────────────────────────────
  CAN_CREATE_STOCK_PURCHASE_ORDER: "CAN_CREATE_STOCK_PURCHASE_ORDER",
  CAN_DISABLE_STOCK_PURCHASE_ORDER: "CAN_DISABLE_STOCK_PURCHASE_ORDER",
  CAN_DISPATCH_STOCK_PURCHASE_ORDER: "CAN_DISPATCH_STOCK_PURCHASE_ORDER",
  CAN_GET_STOCK_PURCHASE_ORDER: "CAN_GET_STOCK_PURCHASE_ORDER",
  CAN_LIST_STOCK_PURCHASE_ORDERS: "CAN_LIST_STOCK_PURCHASE_ORDERS",
  CAN_UPDATE_STOCK_PURCHASE_ORDER: "CAN_UPDATE_STOCK_PURCHASE_ORDER",

  // ─── Offer Controls ───────────────────────────────────────────
  CAN_CREATE_OFFER_CONTROL: "CAN_CREATE_OFFER_CONTROL",
  CAN_DELETE_OFFER_CONTROL: "CAN_DELETE_OFFER_CONTROL",
  CAN_GET_OFFER_CONTROL: "CAN_GET_OFFER_CONTROL",
  CAN_LIST_OFFER_CONTROLS: "CAN_LIST_OFFER_CONTROLS",
  CAN_RECEIVE_OFFER_CONTROL: "CAN_RECEIVE_OFFER_CONTROL",

  // ─── Stock Offer Controls ─────────────────────────────────────
  CAN_CREATE_STOCK_OFFER_CONTROL: "CAN_CREATE_STOCK_OFFER_CONTROL",
  CAN_DELETE_STOCK_OFFER_CONTROL: "CAN_DELETE_STOCK_OFFER_CONTROL",
  CAN_GET_STOCK_OFFER_CONTROL: "CAN_GET_STOCK_OFFER_CONTROL",
  CAN_LIST_STOCK_OFFER_CONTROLS: "CAN_LIST_STOCK_OFFER_CONTROLS",
  CAN_RECEIVE_STOCK_OFFER_CONTROL: "CAN_RECEIVE_STOCK_OFFER_CONTROL",

  // ─── Solicitations ────────────────────────────────────────────
  CAN_APPROVE_SOLICITATION: "CAN_APPROVE_SOLICITATION",
  CAN_CANCEL_SOLICITATION: "CAN_CANCEL_SOLICITATION",
  CAN_CREATE_SOLICITATION: "CAN_CREATE_SOLICITATION",
  CAN_DISPATCH_SOLICITATION: "CAN_DISPATCH_SOLICITATION",
  CAN_GET_SOLICITATION: "CAN_GET_SOLICITATION",
  CAN_LIST_SOLICITATIONS: "CAN_LIST_SOLICITATIONS",
  CAN_PARTIALLY_RECEIVE_SOLICITATION: "CAN_PARTIALLY_RECEIVE_SOLICITATION",
  CAN_RECEIVE_SOLICITATION: "CAN_RECEIVE_SOLICITATION",
  CAN_REJECT_SOLICITATION: "CAN_REJECT_SOLICITATION",
  CAN_SET_AWAITING_APPROVAL_SOLICITATION: "CAN_SET_AWAITING_APPROVAL_SOLICITATION",

  // ─── Milestones ────────────────────────────────────────────────
  CAN_CREATE_MILESTONE: "CAN_CREATE_MILESTONE",
  CAN_DELETE_MILESTONE: "CAN_DELETE_MILESTONE",
  CAN_DELETE_MILESTONE_FILE: "CAN_DELETE_MILESTONE_FILE",
  CAN_GET_MILESTONE: "CAN_GET_MILESTONE",
  CAN_GET_MILESTONE_FILE: "CAN_GET_MILESTONE_FILE",
  CAN_LIST_MILESTONE_FILES: "CAN_LIST_MILESTONE_FILES",
  CAN_LIST_MILESTONES: "CAN_LIST_MILESTONES",
  CAN_UPDATE_MILESTONE: "CAN_UPDATE_MILESTONE",
  CAN_UPLOAD_MILESTONE_FILE: "CAN_UPLOAD_MILESTONE_FILE",

  // ─── Events ────────────────────────────────────────────────────
  CAN_CREATE_EVENT: "CAN_CREATE_EVENT",
  CAN_DELETE_EVENT: "CAN_DELETE_EVENT",
  CAN_GET_EVENT: "CAN_GET_EVENT",
  CAN_LIST_EVENTS: "CAN_LIST_EVENTS",
  CAN_UPDATE_EVENT: "CAN_UPDATE_EVENT",

  // ─── Dependencies ─────────────────────────────────────────────
  CAN_CREATE_DEPENDENCY: "CAN_CREATE_DEPENDENCY",
  CAN_DELETE_DEPENDENCY: "CAN_DELETE_DEPENDENCY",
  CAN_GET_DEPENDENCY: "CAN_GET_DEPENDENCY",
  CAN_LIST_DEPENDENCIES: "CAN_LIST_DEPENDENCIES",
  CAN_UPDATE_DEPENDENCY: "CAN_UPDATE_DEPENDENCY",

  // ─── Notes ─────────────────────────────────────────────────────
  CAN_CREATE_NOTE: "CAN_CREATE_NOTE",
  CAN_DELETE_NOTE: "CAN_DELETE_NOTE",
  CAN_DELETE_NOTE_FILE: "CAN_DELETE_NOTE_FILE",
  CAN_GET_NOTE: "CAN_GET_NOTE",
  CAN_GET_NOTE_FILE: "CAN_GET_NOTE_FILE",
  CAN_LIST_NOTE_FILES: "CAN_LIST_NOTE_FILES",
  CAN_LIST_NOTES: "CAN_LIST_NOTES",
  CAN_UPDATE_NOTE: "CAN_UPDATE_NOTE",
  CAN_UPLOAD_NOTE_FILE: "CAN_UPLOAD_NOTE_FILE",
  CAN_ACCESS_CRM: "CAN_ACCESS_CRM",
  // ─── Website ───────────────────────────────────────────────────
  CAN_LIST_WEBSITE_TEXTS: "CAN_LIST_WEBSITE_TEXTS",
  CAN_GET_WEBSITE_TEXT: "CAN_GET_WEBSITE_TEXT",
  CAN_CREATE_WEBSITE_TEXT: "CAN_CREATE_WEBSITE_TEXT",
  CAN_UPDATE_WEBSITE_TEXT: "CAN_UPDATE_WEBSITE_TEXT",
  CAN_DELETE_WEBSITE_TEXT: "CAN_DELETE_WEBSITE_TEXT",
  CAN_LIST_WEBSITE_IMAGES: "CAN_LIST_WEBSITE_IMAGES",
  CAN_GET_WEBSITE_IMAGE: "CAN_GET_WEBSITE_IMAGE",
  CAN_CREATE_WEBSITE_IMAGE: "CAN_CREATE_WEBSITE_IMAGE",
  CAN_UPDATE_WEBSITE_IMAGE: "CAN_UPDATE_WEBSITE_IMAGE",
  CAN_DELETE_WEBSITE_IMAGE: "CAN_DELETE_WEBSITE_IMAGE",
  // ─── Website News ────────────────────────────────────────────────
  CAN_LIST_WEBSITE_NEWS: "CAN_LIST_WEBSITE_NEWS",
  CAN_GET_WEBSITE_NEWS: "CAN_GET_WEBSITE_NEWS",
  CAN_CREATE_WEBSITE_NEWS: "CAN_CREATE_WEBSITE_NEWS",
  CAN_UPDATE_WEBSITE_NEWS: "CAN_UPDATE_WEBSITE_NEWS",
  CAN_DELETE_WEBSITE_NEWS: "CAN_DELETE_WEBSITE_NEWS",
  // ─── Action History ──────────────────────────────────────────────
  CAN_GET_ACTION_HISTORY: "CAN_GET_ACTION_HISTORY",
  CAN_LIST_ACTION_HISTORY: "CAN_LIST_ACTION_HISTORY",
  CAN_CREATE_ACTION_HISTORY: "CAN_CREATE_ACTION_HISTORY",
  CAN_DELETE_ACTION_HISTORY: "CAN_DELETE_ACTION_HISTORY",
  // ─── Contacts ────────────────────────────────────────────────
  CAN_LIST_CONTACTS: "CAN_LIST_CONTACTS",
  CAN_GET_CONTACT: "CAN_GET_CONTACT",
  CAN_MARK_CONTACT_AS_SEEN: "CAN_MARK_CONTACT_AS_SEEN",
  CAN_ANSWER_CONTACT: "CAN_ANSWER_CONTACT",
  // ─── Submits ────────────────────────────────────────────────
  CAN_LIST_SUBMITS: "CAN_LIST_SUBMITS",
  CAN_UPDATE_SUBMIT: "CAN_UPDATE_SUBMIT",
  CAN_APPROVE_SUBMIT: "CAN_APPROVE_SUBMIT",
  // ─── App Builds ──────────────────────────────────────────────
  CAN_LIST_APP_BUILDS: "CAN_LIST_APP_BUILDS",
  CAN_TRIGGER_APP_BUILD: "CAN_TRIGGER_APP_BUILD",
  CAN_PUBLISH_APP: "CAN_PUBLISH_APP",
  CAN_USE_APP_DEVICE: "CAN_USE_APP_DEVICE",
  // ─── Error Tracking ──────────────────────────────────────────
  CAN_VIEW_ERRORS: "CAN_VIEW_ERRORS",
  CAN_MANAGE_ERRORS: "CAN_MANAGE_ERRORS",
  // ─── Auditoria do Reconhecimento Facial ──────────────────────
  CAN_LIST_USER_FACE_ATTEMPTS: "CAN_LIST_USER_FACE_ATTEMPTS",
  CAN_DELETE_USER_FACE_ATTEMPT: "CAN_DELETE_USER_FACE_ATTEMPT",
} as const;

/**
 * Permissões de nível de projeto (project-scoped).
 * Usadas para controlar acesso em projetos individuais.
 */
export const PROJECT_PERMISSIONS = {
  // ─── Wallet ────────────────────────────────────────────────────
  CAN_ADD_CREDENTIALS_TO_THIS_PROJECT_WALLET: "CAN_ADD_CREDENTIALS_TO_THIS_PROJECT_WALLET",
  CAN_ADD_CREDENTIALS_TO_THIS_PROJECT_STEP_WALLET: "CAN_ADD_CREDENTIALS_TO_THIS_PROJECT_STEP_WALLET",
  CAN_ADD_FILES_TO_THIS_PROJECT_WALLET: "CAN_ADD_FILES_TO_THIS_PROJECT_WALLET",
  CAN_ADD_FILES_TO_THIS_PROJECT_STEP_WALLET: "CAN_ADD_FILES_TO_THIS_PROJECT_STEP_WALLET",
  CAN_CREATE_THIS_PROJECT_WALLET: "CAN_CREATE_THIS_PROJECT_WALLET",
  CAN_CREATE_THIS_PROJECT_STEP_WALLET: "CAN_CREATE_THIS_PROJECT_STEP_WALLET",
  CAN_DELETE_THIS_PROJECT_WALLET: "CAN_DELETE_THIS_PROJECT_WALLET",
  CAN_DELETE_THIS_PROJECT_WALLET_CREDENTIAL: "CAN_DELETE_THIS_PROJECT_WALLET_CREDENTIAL",
  CAN_DELETE_THIS_PROJECT_WALLET_FILE: "CAN_DELETE_THIS_PROJECT_WALLET_FILE",
  CAN_DELETE_THIS_PROJECT_STEP_WALLET: "CAN_DELETE_THIS_PROJECT_STEP_WALLET",
  CAN_DELETE_THIS_PROJECT_STEP_WALLET_CREDENTIAL: "CAN_DELETE_THIS_PROJECT_STEP_WALLET_CREDENTIAL",
  CAN_DELETE_THIS_PROJECT_STEP_WALLET_FILE: "CAN_DELETE_THIS_PROJECT_STEP_WALLET_FILE",
  CAN_GENERATE_PDF_TO_THIS_PROJECT_WALLET: "CAN_GENERATE_PDF_TO_THIS_PROJECT_WALLET",
  CAN_GENERATE_PDF_TO_THIS_PROJECT_STEP_WALLET: "CAN_GENERATE_PDF_TO_THIS_PROJECT_STEP_WALLET",
  CAN_GENERATE_SPREADSHEET_TO_THIS_PROJECT_WALLET: "CAN_GENERATE_SPREADSHEET_TO_THIS_PROJECT_WALLET",
  CAN_GENERATE_SPREADSHEET_TO_THIS_PROJECT_STEP_WALLET: "CAN_GENERATE_SPREADSHEET_TO_THIS_PROJECT_STEP_WALLET",

  // ─── Project ───────────────────────────────────────────────────
  CAN_DISABLE_THIS_PROJECT: "CAN_DISABLE_THIS_PROJECT",
  CAN_DISABLE_THIS_PROJECT_STEP: "CAN_DISABLE_THIS_PROJECT_STEP",

  // ─── Steps / Tasks ─────────────────────────────────────────────
  CAN_CREATE_THIS_PROJECT_STEP: "CAN_CREATE_THIS_PROJECT_STEP",
  CAN_DELETE_THIS_PROJECT_STEP: "CAN_DELETE_THIS_PROJECT_STEP",
  CAN_CREATE_THIS_PROJECT_TASK: "CAN_CREATE_THIS_PROJECT_TASK",
  CAN_DELETE_THIS_PROJECT_TASK: "CAN_DELETE_THIS_PROJECT_TASK",
  CAN_FINISH_THIS_PROJECT_TASK: "CAN_FINISH_THIS_PROJECT_TASK",

  // ─── Diary ─────────────────────────────────────────────────────
  CAN_CREATE_THIS_PROJECT_DIARY: "CAN_CREATE_THIS_PROJECT_DIARY",
  CAN_CREATE_THIS_PROJECT_WORKER_DIARY: "CAN_CREATE_THIS_PROJECT_WORKER_DIARY",
  CAN_DELETE_THIS_PROJECT_DIARY_IMAGE: "CAN_DELETE_THIS_PROJECT_DIARY_IMAGE",
  CAN_DELETE_THIS_PROJECT_IMAGE: "CAN_DELETE_THIS_PROJECT_IMAGE",

  // ─── Workers ───────────────────────────────────────────────────
  CAN_CREATE_WORKER_PROFILE_IN_THIS_PROJECT: "CAN_CREATE_WORKER_PROFILE_IN_THIS_PROJECT",
  CAN_DELETE_THIS_PROJECT_WORKER: "CAN_DELETE_THIS_PROJECT_WORKER",

  // ─── Financial ─────────────────────────────────────────────────
  CAN_CREATE_THIS_PROJECT_OFFER: "CAN_CREATE_THIS_PROJECT_OFFER",
  CAN_CREATE_THIS_PROJECT_OFFER_COST: "CAN_CREATE_THIS_PROJECT_OFFER_COST",
  CAN_CREATE_THIS_PROJECT_RECEIVEMENT: "CAN_CREATE_THIS_PROJECT_RECEIVEMENT",
  CAN_CREATE_THIS_PROJECT_STEP_COSTS_OFFER_COST: "CAN_CREATE_THIS_PROJECT_STEP_COSTS_OFFER_COST",
  CAN_DELETE_THIS_PROJECT_OFFER: "CAN_DELETE_THIS_PROJECT_OFFER",
  CAN_DELETE_THIS_PROJECT_OFFER_COST: "CAN_DELETE_THIS_PROJECT_OFFER_COST",
  CAN_DELETE_THIS_PROJECT_RECEIVEMENT: "CAN_DELETE_THIS_PROJECT_RECEIVEMENT",
  CAN_DELETE_THIS_PROJECT_STEP_COSTS_OFFER_COST: "CAN_DELETE_THIS_PROJECT_STEP_COSTS_OFFER_COST",
  CAN_LIST_THIS_PROJECT_COST_STEP_COSTS: "CAN_LIST_THIS_PROJECT_COST_STEP_COSTS",

  // ─── Stock ─────────────────────────────────────────────────────
  CAN_GET_THIS_PROJECT_STOCK: "CAN_GET_THIS_PROJECT_STOCK",
  CAN_CREATE_THIS_PROJECT_STOCK_TOOL: "CAN_CREATE_THIS_PROJECT_STOCK_TOOL",
  CAN_DELETE_THIS_PROJECT_STOCK_TOOL: "CAN_DELETE_THIS_PROJECT_STOCK_TOOL",

  // ─── Purchase Orders (Project) ─────────────────────────────────
  CAN_CREATE_THIS_PROJECT_PURCHASE_ORDER: "CAN_CREATE_THIS_PROJECT_PURCHASE_ORDER",
  CAN_CREATE_THIS_PROJECT_PURCHASE_ORDER_LIST: "CAN_CREATE_THIS_PROJECT_PURCHASE_ORDER_LIST",
  CAN_CREATE_THIS_PROJECT_PURCHASE_ORDERS_OFFER_COST: "CAN_CREATE_THIS_PROJECT_PURCHASE_ORDERS_OFFER_COST",
  CAN_DELETE_THIS_PROJECT_PURCHASE_ORDER: "CAN_DELETE_THIS_PROJECT_PURCHASE_ORDER",
  CAN_DELETE_THIS_PROJECT_PURCHASE_ORDERS_OFFER_COST: "CAN_DELETE_THIS_PROJECT_PURCHASE_ORDERS_OFFER_COST",
  CAN_DISABLE_THIS_PROJECT_PURCHASE_ORDER: "CAN_DISABLE_THIS_PROJECT_PURCHASE_ORDER",
  CAN_DISABLE_THIS_PROJECT_PURCHASE_ORDER_LIST: "CAN_DISABLE_THIS_PROJECT_PURCHASE_ORDER_LIST",
  CAN_DISPATCH_THIS_PROJECT_PURCHASE_ORDER: "CAN_DISPATCH_THIS_PROJECT_PURCHASE_ORDER",
  CAN_DISPATCH_THIS_PROJECT_PURCHASE_ORDER_LIST: "CAN_DISPATCH_THIS_PROJECT_PURCHASE_ORDER_LIST",
  CAN_GET_THIS_PROJECT_PURCHASE_ORDER_LIST: "CAN_GET_THIS_PROJECT_PURCHASE_ORDER_LIST",
  CAN_LIST_THIS_PROJECT_PURCHASE_ORDER_LISTS: "CAN_LIST_THIS_PROJECT_PURCHASE_ORDER_LISTS",

  // ─── Offer Controls (Project) ─────────────────────────────────
  CAN_CREATE_THIS_PROJECT_OFFER_CONTROL: "CAN_CREATE_THIS_PROJECT_OFFER_CONTROL",
  CAN_DELETE_THIS_PROJECT_OFFER_CONTROL: "CAN_DELETE_THIS_PROJECT_OFFER_CONTROL",
  CAN_GET_THIS_PROJECT_OFFER_CONTROL: "CAN_GET_THIS_PROJECT_OFFER_CONTROL",
  CAN_LIST_THIS_PROJECT_OFFER_CONTROLS: "CAN_LIST_THIS_PROJECT_OFFER_CONTROLS",
  CAN_RECEIVE_THIS_PROJECT_OFFER_CONTROL: "CAN_RECEIVE_THIS_PROJECT_OFFER_CONTROL",

  // ─── Milestones (Project) ─────────────────────────────────────
  CAN_CREATE_THIS_PROJECT_MILESTONE: "CAN_CREATE_THIS_PROJECT_MILESTONE",
  CAN_DELETE_THIS_PROJECT_MILESTONE: "CAN_DELETE_THIS_PROJECT_MILESTONE",
  CAN_DELETE_THIS_PROJECT_MILESTONE_FILE: "CAN_DELETE_THIS_PROJECT_MILESTONE_FILE",
  CAN_GET_THIS_PROJECT_MILESTONE: "CAN_GET_THIS_PROJECT_MILESTONE",
  CAN_GET_THIS_PROJECT_MILESTONE_FILE: "CAN_GET_THIS_PROJECT_MILESTONE_FILE",
  CAN_LIST_THIS_PROJECT_MILESTONE_FILES: "CAN_LIST_THIS_PROJECT_MILESTONE_FILES",
  CAN_LIST_THIS_PROJECT_MILESTONES: "CAN_LIST_THIS_PROJECT_MILESTONES",
  CAN_UPDATE_THIS_PROJECT_MILESTONE: "CAN_UPDATE_THIS_PROJECT_MILESTONE",
  CAN_UPLOAD_THIS_PROJECT_MILESTONE_FILE: "CAN_UPLOAD_THIS_PROJECT_MILESTONE_FILE",

  // ─── Events (Project) ─────────────────────────────────────────
  CAN_CREATE_THIS_PROJECT_EVENT: "CAN_CREATE_THIS_PROJECT_EVENT",
  CAN_DELETE_THIS_PROJECT_EVENT: "CAN_DELETE_THIS_PROJECT_EVENT",
  CAN_GET_THIS_PROJECT_EVENT: "CAN_GET_THIS_PROJECT_EVENT",
  CAN_LIST_THIS_PROJECT_EVENTS: "CAN_LIST_THIS_PROJECT_EVENTS",
  CAN_UPDATE_THIS_PROJECT_EVENT: "CAN_UPDATE_THIS_PROJECT_EVENT",

  // ─── Dependencies (Project) ───────────────────────────────────
  CAN_CREATE_THIS_PROJECT_DEPENDENCY: "CAN_CREATE_THIS_PROJECT_DEPENDENCY",
  CAN_DELETE_THIS_PROJECT_DEPENDENCY: "CAN_DELETE_THIS_PROJECT_DEPENDENCY",
  CAN_GET_THIS_PROJECT_DEPENDENCY: "CAN_GET_THIS_PROJECT_DEPENDENCY",
  CAN_LIST_THIS_PROJECT_DEPENDENCIES: "CAN_LIST_THIS_PROJECT_DEPENDENCIES",
  CAN_UPDATE_THIS_PROJECT_DEPENDENCY: "CAN_UPDATE_THIS_PROJECT_DEPENDENCY",

  // ─── Notes (Project) ──────────────────────────────────────────
  CAN_CREATE_THIS_PROJECT_NOTE: "CAN_CREATE_THIS_PROJECT_NOTE",
  CAN_DELETE_THIS_PROJECT_NOTE: "CAN_DELETE_THIS_PROJECT_NOTE",
  CAN_DELETE_THIS_PROJECT_NOTE_FILE: "CAN_DELETE_THIS_PROJECT_NOTE_FILE",
  CAN_GET_THIS_PROJECT_NOTE: "CAN_GET_THIS_PROJECT_NOTE",
  CAN_GET_THIS_PROJECT_NOTE_FILE: "CAN_GET_THIS_PROJECT_NOTE_FILE",
  CAN_LIST_THIS_PROJECT_NOTE_FILES: "CAN_LIST_THIS_PROJECT_NOTE_FILES",
  CAN_LIST_THIS_PROJECT_NOTES: "CAN_LIST_THIS_PROJECT_NOTES",
  CAN_UPDATE_THIS_PROJECT_NOTE: "CAN_UPDATE_THIS_PROJECT_NOTE",
  CAN_UPLOAD_THIS_PROJECT_NOTE_FILE: "CAN_UPLOAD_THIS_PROJECT_NOTE_FILE",
} as const;

type PermissionKey = keyof typeof PERMISSIONS;
type PermissionValue = (typeof PERMISSIONS)[PermissionKey];

type ProjectPermissionKey = keyof typeof PROJECT_PERMISSIONS;
type ProjectPermissionValue = (typeof PROJECT_PERMISSIONS)[ProjectPermissionKey];
